<div id="wrap" [@wrapAnimation] (click)="screenClick()">
    <div id="reviewBox" class="fontSize16">
        场景回顾
    </div>

    <div id="nextStep" [@nextStepAnimation]="nextStepShow ? 'showNextStep' : 'hideNextStep'">
        <img src="{{assetsRoute}}/picture/casepracticepando/click.png" alt="" id="clickIcon">
        <div id="nextStepText" class="fontSize18">
            <span class="textVerticalCenter">点击屏幕任意处可以进行下一步操作</span>
        </div>
    </div>

    <div id="description1" [@description1Animation]="description1Show ? 'showDescription1' : 'hideDescription1'" class="fontSize18">
        <span class="textVerticalCenter">
            我任职于一家全球领先的信息与通信技术解决方案供应商，是海外事业部主管。<br/><br/>
            我带领着一个团队…
        </span>
    </div>

    <img src="{{assetsRoute}}/picture/casepracticepando/gl1.png" alt="" id="gl">
    <img src="{{assetsRoute}}/picture/casepracticepando/wln1.png" alt="" id="wln">
    <img src="{{assetsRoute}}/picture/casepracticepando/fkk1.png" alt="" id="fkk">
    <img src="{{assetsRoute}}/picture/casepracticepando/qf.png" alt="" id="qf">

    <div id="glBox" [@glAnimation]="glBoxShow ? 'showGlBox' : 'hideGlBox'" class="descriptionBox fontSize16">
        <div class="nameBox nameBox1 fontSize16">
            高朗
        </div>
        <span>
            刚入职3个月的新人<br/>
            对公司的产品不太熟悉
        </span>
    </div>

    <div id="wlnBox" [@wlnAnimation]="wlnBoxShow ? 'showWlnBox' : 'hideWlnBox'" class="descriptionBox fontSize16">
        <div class="nameBox nameBox1 fontSize16">
            王立娜
        </div>
        <span>
            年限最长<br/>
            最熟悉公司业务<br/>
            负责重要海外客户维系
        </span>
    </div>

    <div id="fkkBox" [@fkkAnimation]="fkkBoxShow ? 'showFkkBox' : 'hideFkkBox'" class="descriptionBox fontSize16">
        <div class="nameBox nameBox2 fontSize16">
            方科科
        </div>
        <span>
            最懂技术<br/>
            负责解答技术问题
        </span>
    </div>

    <div id="qfBox" [@qfAnimation]="qfBoxShow ? 'showQfBox' : 'hideQfBox'" class="descriptionBox fontSize16">
        <div class="nameBox nameBox2 fontSize16">
            秦飞
        </div>
        <span>
            资深客户经理<br/>
            对行业和业务都非常熟悉
        </span>
    </div>

    <div id="description2" [@description2Animation]="description2Show ? 'showDescription2' : 'hideDescription2'" class="fontSize18">
        <span class="textVerticalCenter">
            公司今年制定了一项非常重要的战略，要拓展北美市场。海外事业部在1月将有四个任务需要完成…
        </span>
    </div>

    <div id="task0" [@icon0Animation]="icon0Show ? 'showIcon0' : 'hideIcon0'"  class="task">
      <img src="{{assetsRoute}}/picture/casepracticepando/positionIcon.png" alt="" id="positionIcon0" class="positionIcon">
      <div id="taskBox0" class="taskBox fontSize16 lineHeight30">
          <span class="taskBoxTitle">任务1</span><br/>
          <span class="taskBoxItem">时间：</span><span class="taskBoxItemContent">1月25-31日</span><br/>
          <span class="taskBoxItem">地点：</span><span class="taskBoxItemContent">旧金山</span><br/>
          <span class="taskBoxItem">内容：</span><span class="taskBoxItemContent">国际通信技术产品展览会</span><br/>
          <span class="taskBoxItem">要求：</span><span class="taskBoxItemContent">尽量让团队全员参与，开发尽可能多的潜在客户</span>
      </div>
      <div id="taskBox0-arrow" class="arrow-down">
      </div>
    </div>
    <div id="task1" [@icon1Animation]="icon1Show ? 'showIcon1' : 'hideIcon1'"  class="task">
      <img src="{{assetsRoute}}/picture/casepracticepando/positionIcon.png" alt="" id="positionIcon1" class="positionIcon">
      <div id="taskBox1" class="taskBox fontSize16 lineHeight30">
          <span class="taskBoxTitle">任务2</span><br/>
          <span class="taskBoxItem">时间：</span><span class="taskBoxItemContent">1月25-27日</span><br/>
          <span class="taskBoxItem">地点：</span><span class="taskBoxItemContent">国内</span><br/>
          <span class="taskBoxItem">内容：</span><span class="taskBoxItemContent">几个王立娜负责维系的重要海外客户即将来访，必须予以接待</span><br/>
          <span class="taskBoxItem">要求：</span><span class="taskBoxItemContent">对方希望“我”能亲自接待</span>
      </div>
      <div id="taskBox1-arrow" class="arrow-down">
      </div>
    </div>
    <div id="task2" [@icon2Animation]="icon2Show ? 'showIcon2' : 'hideIcon2'"  class="task">
      <img src="{{assetsRoute}}/picture/casepracticepando/positionIcon.png"  alt="" id="positionIcon2" class="positionIcon">
      <div id="taskBox2" class="taskBox fontSize16 lineHeight30">
          <span class="taskBoxTitle">任务3</span><br/>
          <span class="taskBoxItem">时间：</span><span class="taskBoxItemContent">1月27日</span><br/>
          <span class="taskBoxItem">地点：</span><span class="taskBoxItemContent">国内</span><br/>
          <span class="taskBoxItem">内容：</span><span class="taskBoxItemContent">一场针对海外市场的活动，让老客户了解公司新产品的技术</span><br/>
          <span class="taskBoxItem">要求：</span><span class="taskBoxItemContent">需要技术大拿方科科支持</span>
      </div>
      <div id="taskBox2-arrow" class="arrow-down">
      </div>
    </div>
    <div id="task3" [@icon3Animation]="icon3Show ? 'showIcon3' : 'hideIcon3'"  class="task">
      <img src="{{assetsRoute}}/picture/casepracticepando/positionIcon.png" alt="" id="positionIcon3" class="positionIcon">

      <div id="taskBox3" class="taskBox fontSize16 lineHeight30">
          <span class="taskBoxTitle">任务4</span><br/>
          <span class="taskBoxItem">时间：</span><span class="taskBoxItemContent">1月27日</span><br/>
          <span class="taskBoxItem">地点：</span><span class="taskBoxItemContent">国内</span><br/>
          <span class="taskBoxItem">内容：</span><span class="taskBoxItemContent">新员工培训</span><br/>
          <span class="taskBoxItem">要求：</span><span class="taskBoxItemContent">HR需要我们部门派人参加，为新员工介绍公司产品在海外市场的情况</span>
      </div>
      <div id="taskBox3-arrow" class="arrow-down">
       </div>
    </div>

    <img src="{{assetsRoute}}/picture/casepracticepando/earth.png" [@earthAnimation]="earthShow ? 'showEarth' : 'hideEarth'" alt=""  id="earth">
    <img src="{{assetsRoute}}/picture/casepracticepando/timetable.png" [@timeTableAnimation]="timeTableShow ? 'showTimeTable' : 'hideTimeTable'" alt="" id="timeTable">


</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-p-and-o-previous/case-practice-p-and-o-previous.component.html